export const treeViewStyles = {
  wrapper: {
    minHeight: 500,
    height: 'calc(100vh - 430px)',
    overflowY: 'auto',
    mt: 2,
  },
};

export const treeItemStyles = {
  '& .MuiTreeItem-content': {
    borderRadius: '8px',
  },
  '& .MuiTreeItem-content:hover': {
    backgroundColor: 'transparent !important',
  },
  '& .MuiTreeItem-content.Mui-selected': {
    backgroundColor: 'transparent !important',
  },
  '& .MuiTreeItem-content.Mui-focused': {
    backgroundColor: 'transparent !important',
  },
  '& .MuiTreeItem-label': {
    pr: 2,
    my: 0.3,
    py: 0.5,
    px: 1.5,
    borderRadius: '6px',
  },
  '& .MuiTreeItem-group': {
    ml: 2,
    pl: 1,
    borderLeft: '2px dashed #E0E0E0',
  },
};

export const nodeLabelStackStyles = {
  borderRadius: '6px',
  width: '100%',
  px: 1.5,
};

export const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    height: 'max-content',
    fontSize: 14,
    paddingRight: 0,
  },
  '& input': {
    padding: '8px',
  },
};
